(() => {
  const statusSelector = '[data-coverking-status]';
  const root = window.Shopify?.routes?.root || '/';

  const updateStatus = (message, state = '') => {
    document.querySelectorAll(statusSelector).forEach((node) => {
      node.textContent = message;
      if (state) node.dataset.state = state;
      else delete node.dataset.state;
    });
  };

  const getRowLabel = (description = '') => {
    const normalized = String(description).toLowerCase();
    if (normalized.includes('front')) return 'Front row';
    if (normalized.includes('rear')) return 'Rear row';
    return 'Item';
  };

  const getSafeImageUrl = (value) => {
    if (typeof value !== 'string' || value.trim() === '') return '';

    try {
      const imageUrl = new URL(value, window.location.href);
      return imageUrl.protocol === 'https:' ? imageUrl.href : '';
    } catch (_error) {
      return '';
    }
  };

  const getCoverkingImageUrl = (imgURL, coverkingSKU = '') => {
    const suppliedImage = getSafeImageUrl(imgURL);
    const skuCode = String(coverkingSKU).trim().split('-').pop().toUpperCase();
    const floorMatMatch = skuCode.match(/^(DFM[A-Z0-9]*?)(M\d+)$/);
    const dashCoverMatch = skuCode.match(/^CDC[A-Z0-9]+$/);
    const carCoverMatch = skuCode.match(/^CVC\d+([A-Z0-9]+)$/);
    const sunshadeMatch = skuCode.match(/^CSS[A-Z0-9]+$/);
    const cargoLinerMatch = skuCode.match(/^CCL[A-Z0-9]+$/);

    if (floorMatMatch) {
      const [, floorMatStyle, materialCode] = floorMatMatch;
      return `https://coverking.azureedge.net/cdn/DFM/${floorMatStyle}3${materialCode}.jpg`;
    }

    if (dashCoverMatch) {
      return `https://coverking.azureedge.net/cdn/CDC/${skuCode}.jpg`;
    }

    if (carCoverMatch) {
      return `https://coverking.azureedge.net/cdn/CVC/CVC${carCoverMatch[1]}.jpg`;
    }

    if (sunshadeMatch) {
      return `https://coverking.azureedge.net/cdn/CSS/${skuCode}.jpg`;
    }

    if (cargoLinerMatch) {
      return `${window.location.origin}/cdn/shop/files/${skuCode}.jpg`;
    }

    return suppliedImage;
  };

  const enhancedAddToCart = async (imgURL, DealerTrx, OptionDescription, CoverkingSKU, shopifyvariant) => {
    const variantId = Number(shopifyvariant);
    const rowLabel = getRowLabel(OptionDescription);
    const selectedImage = getCoverkingImageUrl(imgURL, CoverkingSKU);

    if (!variantId) {
      updateStatus('We could not identify the selected item. Please refresh the page and try again.', 'error');
      return;
    }

    const properties = {
      DealerTrx,
      OptionDescription,
      CoverkingSKU,
    };

    if (selectedImage) properties._CoverkingImage = selectedImage;

    updateStatus(`Adding ${rowLabel.toLowerCase()} to your cart…`, 'loading');

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties }],
        }),
      });

      if (!response.ok) throw new Error(`Cart request failed with ${response.status}`);

      if (typeof window.UpdateCart === 'function') window.UpdateCart();

      const reminder = rowLabel === 'Front row'
        ? ' Front and rear rows are separate—add the rear row too if you need it.'
        : '';
      updateStatus(`${rowLabel} added to cart.${reminder}`, 'success');

      document.dispatchEvent(new CustomEvent('coverking:item-added', {
        detail: { row: rowLabel, image: selectedImage },
      }));
    } catch (error) {
      console.error('Coverking cart add failed', error);
      updateStatus('That item was not added. Please try Add To Cart again.', 'error');
    }
  };

  enhancedAddToCart.__coverkingEnhanced = true;

  const installEnhancement = () => {
    if (typeof window.AddToCart !== 'function') return false;
    if (window.AddToCart.__coverkingEnhanced) return true;

    window.AddToCart = enhancedAddToCart;
    return true;
  };

  installEnhancement();
  document.addEventListener('DOMContentLoaded', installEnhancement, { once: true });
  window.addEventListener('pageshow', installEnhancement);

  let attempts = 0;
  const installer = window.setInterval(() => {
    attempts += 1;
    installEnhancement();
    if (attempts >= 80) window.clearInterval(installer);
  }, 250);
})();

